const currencyFormatter = new Intl.NumberFormat("en-KE", {
  style: "currency",
  currency: "KES",
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const percentFormatter = new Intl.NumberFormat("en-US", {
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
});

const compactNumberFormatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export const formatCurrency = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }

  return currencyFormatter.format(Number(value));
};

export const formatPercent = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }

  return `${percentFormatter.format(Number(value))}%`;
};

export const formatCount = (value) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return "—";
  }

  return compactNumberFormatter.format(Number(value));
};

export const formatStatusLabel = (value) => (value ? "Up to date" : "Needs attention");

export const formatFocusAreaLabel = (value) => {
  if (!value) return "No focus area";

  return value
    .split("-")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
};

export const formatRelativeDateTime = (value) => {
  if (!value) return "Not updated yet";

  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "Not updated yet";

  const diffMs = date.getTime() - Date.now();
  const absSeconds = Math.abs(diffMs) / 1000;
  const rtf = new Intl.RelativeTimeFormat("en", { numeric: "auto" });

  if (absSeconds < 60) return "Updated just now";
  if (absSeconds < 3600) {
    return `Updated ${rtf.format(Math.round(diffMs / 60000), "minute")}`;
  }
  if (absSeconds < 86400) {
    return `Updated ${rtf.format(Math.round(diffMs / 3600000), "hour")}`;
  }
  if (absSeconds < 604800) {
    return `Updated ${rtf.format(Math.round(diffMs / 86400000), "day")}`;
  }

  return `Updated ${date.toLocaleString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  })}`;
};

export const maskEmail = (email) => {
  if (!email || typeof email !== "string") return "—";

  const trimmedEmail = email.trim();
  if (!trimmedEmail) return "—";

  const atIndex = trimmedEmail.indexOf("@");
  if (atIndex <= 0 || atIndex !== trimmedEmail.lastIndexOf("@")) return trimmedEmail;

  const localPart = trimmedEmail.slice(0, atIndex);
  const domain = trimmedEmail.slice(atIndex + 1);
  if (!domain) return trimmedEmail;

  if (localPart.length <= 2) return `${localPart[0] || ""}*****@${domain}`;

  const firstVisible = localPart.slice(0, 2);
  const lastVisible = localPart.slice(-1);
  return `${firstVisible}*****${lastVisible}@${domain}`;
};

export const maskPhone = (phone) => {
  if (phone === null || phone === undefined) return "—";

  const phoneString = String(phone).trim();
  if (!phoneString) return "—";

  const digits = phoneString.replace(/\D/g, "");
  if (!digits) return "—";
  if (digits.length <= 4) return `${digits.slice(0, 1)}***${digits.slice(-1)}`;

  const firstVisible = digits.slice(0, 2);
  const lastVisible = digits.slice(-3);
  return `${firstVisible}*****${lastVisible}`;
};
